import { render, staticRenderFns } from "./HeaderChangeFlavour.vue?vue&type=template&id=0e3698bb&"
import script from "./HeaderChangeFlavour.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HeaderChangeFlavour.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e3698bb')) {
      api.createRecord('0e3698bb', component.options)
    } else {
      api.reload('0e3698bb', component.options)
    }
    module.hot.accept("./HeaderChangeFlavour.vue?vue&type=template&id=0e3698bb&", function () {
      api.rerender('0e3698bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/HeaderChangeFlavour.vue"
export default component.exports